<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { formatWeekdayDate } from '@/utils/datetime'

const props = defineProps({
  date: { type: [Date, String], required: true },
  fullWeekday: { type: Boolean, default: false },
  badge: { type: Boolean, default: false },
})

const { t } = useI18n()

const formatted = computed(() => formatWeekdayDate(props.date, t, props.fullWeekday))

// Split "Pn, 12.10.2026" into weekday and date; the date part never contains a comma
const parts = computed(() => {
  const separatorIndex = formatted.value.lastIndexOf(', ')

  return {
    weekday: formatted.value.slice(0, separatorIndex),
    date: formatted.value.slice(separatorIndex + 2),
  }
})
</script>

<template>
  <span
    v-if="formatted"
    class="font-weight-medium"
  >
    <VChip
      v-if="badge"
      class="weekday-badge mr-1 mt-n1"
      size="x-small"
      variant="elevated"
    >
      {{ parts.weekday }}
    </VChip>
    <template v-else>{{ parts.weekday }},</template>
    {{ parts.date }}
  </span>
</template>

<style scoped>
.v-chip.weekday-badge {
  padding-inline: 6px !important;
  border-radius: 5px !important;
  font-size: 12px !important;
}
</style>
